// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"d9aa76a2","140":"a4c49d1b","453":"a492ffeb"}[chunkId] + ".chunk.js";
};